import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { BuyerPromotionForm } from "@/components/buyer-promotions/buyer-promotion-form"
import {
	type BuyerPromotionFormValues,
	toCreateBuyerPromotionInput,
} from "@/components/buyer-promotions/buyer-promotion-form.helpers"
import { useAdminRoles } from "@/hooks/use-admin-roles"
import { useCreateBuyerPromotion } from "@/queries/marketplace"

export const Route = createFileRoute("/buyer-promotions/new")({
	component: CreateBuyerPromotionPage,
})

function CreateBuyerPromotionPage() {
	const navigate = useNavigate()
	const createMutation = useCreateBuyerPromotion()
	const { hasRole, isLoading: rolesLoading } = useAdminRoles()

	const handleSubmit = useCallback(
		async (values: BuyerPromotionFormValues) => {
			const promotion = await createMutation.mutateAsync(
				toCreateBuyerPromotionInput(values),
			)
			navigate({
				to: "/buyer-promotions/$promotionId",
				params: { promotionId: promotion.id },
			})
		},
		[createMutation, navigate],
	)

	if (!rolesLoading && !hasRole(AdminRole.MarketplaceCoupons)) {
		return (
			<div className="p-6">
				<p className="text-muted-foreground">
					Only admins with the coupons role can create buyer promotions.
				</p>
			</div>
		)
	}

	return (
		<BuyerPromotionForm
			mode="create"
			onSubmit={handleSubmit}
			isSubmitting={createMutation.isPending}
		/>
	)
}
